import React from 'react';
import { motion } from 'framer-motion';
import { 
  Brush, Video, Globe, FileText, Database, DollarSign 
} from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Brush,
      title: 'Graphics Design',
      description: 'Professional design for logos, branding, social media graphics',
      price: '$3-$15',
      features: ['Logo Design', 'Branding', 'Social Media Graphics', 'Illustrations']
    },
    {
      icon: Video,
      title: 'Video Editing',
      description: 'Creative video editing for content creators',
      price: '$3-$50',
      features: ['Short Videos', 'Promotional Videos', 'Social Media Clips', 'Basic Animation']
    },
    {
      icon: Globe,
      title: 'Web Development',
      description: 'Responsive and modern website solutions',
      price: '$200-$1500',
      features: ['React Websites', 'WordPress Sites', 'E-commerce', 'Landing Pages']
    },
    {
      icon: Database,
      title: 'Data Entry',
      description: 'Accurate and efficient data management',
      price: '$5-$20/hr',
      features: ['Excel Work', 'Database Management', 'Data Cleaning', 'Form Filling']
    },
    {
      icon: FileText,
      title: 'WordPress Development',
      description: 'Custom WordPress solutions',
      price: '$150-$800',
      features: ['Theme Customization', 'Plugin Integration', 'E-commerce Sites', 'Blog Setup']
    }
  ];

  return (
    <div className="sm:mt-8  md:pt-6 lg:pt-8 pt-10">
    <div className="min-h-screen bg-gray-900 py-16 px-4">
      <div className="container mx-auto">
        <motion.h2 
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-4xl md:text-5xl text-center mb-12 font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-cyan-500"
        >
          Our Affordable Services
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.2 }}
              className="bg-gray-800/50 rounded-xl p-6 border border-purple-500/30 hover:border-cyan-500/50 transition-all"
            >
              <div className="flex items-center mb-4">
                <service.icon className="text-cyan-500 mr-4" size={40} />
                <h3 className="text-2xl font-semibold text-white">{service.title}</h3>
              </div>
              <p className="text-gray-400 mb-4">{service.description}</p>
              <div className="flex items-center mb-4">
                <DollarSign className="text-green-500 mr-2" size={20} />
                <span className="text-xl font-bold text-green-400">{service.price}</span>
              </div>
              <ul className="space-y-2 text-gray-300">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center">
                    <span className="w-2 h-2 mr-2 bg-cyan-500 rounded-full"></span>
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
    </div>

  );
};

export default Services;